/* =================== SLIDE HOME =================== */
$(function () {
  const slideItems = $(".slide-home > a").length;
  const slideDots = slideItems > 1;
  $(".slide-home")
    .on("init", function () {
      $(".slide-content").show();
    })
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: slideDots,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 760,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  /*.on("beforeChange", function () {
      $(".slide-content").hide();
    })
    .on("afterChange", function () {
      $(".slide-content").show();
    });*/
});
